// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationFooter-module__evaluatorFooter {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 84px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 38px;
  box-shadow: 0px -8px 20px 6px #7171a81a;
  z-index: 1000;
}

.EvaluationFooter-module__previousButton {
  height: 44px;
  opacity: 1;
  border-radius: 70px;
  padding-top: 12px;
  padding-right: 20px;
  padding-bottom: 12px;
  padding-left: 20px;
  gap: 8px;
  border: 1px solid #2636434d;
  background-color: transparent;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 8%;
  text-align: center;
  text-transform: uppercase;
  color: #263643;
  cursor: pointer;
  transition: all 0.2s ease;
}

.EvaluationFooter-module__previousButton:hover {
  background-color: #d8edfe;
  transform: translateY(-2px);
}

.EvaluationFooter-module__approvalButton {
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  border-radius: 40px;
  padding-top: 12px;
  padding-right: 24px;
  padding-bottom: 12px;
  padding-left: 24px;
  gap: 4px;
  background-color: #00354e;
  color: #fcfcfc;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}

.EvaluationFooter-module__approvalButton:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.6;
}

.EvaluationFooter-module__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(252, 252, 252, 0.3);
  border-top-color: #fcfcfc;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/evaluation/EvaluationFooter.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".evaluatorFooter {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 84px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 0 38px;\n  box-shadow: 0px -8px 20px 6px #7171a81a;\n  z-index: 1000;\n}\n\n.previousButton {\n  height: 44px;\n  opacity: 1;\n  border-radius: 70px;\n  padding-top: 12px;\n  padding-right: 20px;\n  padding-bottom: 12px;\n  padding-left: 20px;\n  gap: 8px;\n  border: 1px solid #2636434d;\n  background-color: transparent;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 8%;\n  text-align: center;\n  text-transform: uppercase;\n  color: #263643;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.previousButton:hover {\n  background-color: #d8edfe;\n  transform: translateY(-2px);\n}\n\n.approvalButton {\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  border-radius: 40px;\n  padding-top: 12px;\n  padding-right: 24px;\n  padding-bottom: 12px;\n  padding-left: 24px;\n  gap: 4px;\n  background-color: #00354e;\n  color: #fcfcfc;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.approvalButton:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(252, 252, 252, 0.3);\n  border-top-color: #fcfcfc;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"evaluatorFooter": `EvaluationFooter-module__evaluatorFooter`,
	"previousButton": `EvaluationFooter-module__previousButton`,
	"approvalButton": `EvaluationFooter-module__approvalButton`,
	"spinner": `EvaluationFooter-module__spinner`
};
export default ___CSS_LOADER_EXPORT___;
